// Sample skill catalogue for Phase 1. Six skills cover the main shapes the
// simulator needs to exercise: a low-CD basic, a single-target spell, an AoE,
// a heal, a stacking-debuff applier, and an ultimate.
//
// Skill IDs are stable strings; the registry is consumed by the tick loop
// when it resolves AI decisions.
//
// ADR 0015 §4.5 / §7.4: `@renavora/content` の `ITEM_SKILLS` (装備スキル
// catalogue 約 400 個、命名 `item.*`) を本 registry に merge する。sample skill
// (`basic_strike` 等) / ultimate skill (job 別 skillId) と命名空間で衝突なし
// (item-skills.test.ts §J #1 で検証)。
// ADR 0025: content の `ULTIMATE_SKILLS` (44 ジョブの ultimate Skill オブジェクト、
// 命名 `ult.<job>.<name>`、ADR 0011) も merge し、`candidates.ts` が `entity.ultimate`
// の skill を解決できるようにする。
import { ITEM_SKILLS, ULTIMATE_SKILL_BY_ID } from '@renavora/content';
import { seconds } from '@renavora/shared';
const sampleSkills = {
    basic_strike: {
        id: 'basic_strike',
        name: 'Basic Strike',
        source: 'item',
        kind: 'active',
        cooldownTicks: seconds(1),
        range: 5,
        targeting: { shape: 'singleTarget' },
        activation: {},
        effects: [{ kind: 'damage', element: 'physical', power: 2.0 }],
    },
    fireball: {
        id: 'fireball',
        name: 'Fireball',
        source: 'item',
        kind: 'active',
        cooldownTicks: seconds(3),
        range: 20,
        targeting: { shape: 'singleTarget' },
        activation: {},
        effects: [{ kind: 'damage', element: 'fire', power: 3.0 }],
    },
    flame_burst: {
        id: 'flame_burst',
        name: 'Flame Burst',
        source: 'item',
        kind: 'active',
        cooldownTicks: seconds(6),
        range: 18,
        targeting: { shape: 'circle', radius: 5, maxTargets: 5 },
        activation: {},
        effects: [{ kind: 'damage', element: 'fire', power: 1.5 }],
    },
    bleed_strike: {
        id: 'bleed_strike',
        name: 'Bleed Strike',
        source: 'item',
        kind: 'active',
        cooldownTicks: seconds(2),
        range: 5,
        targeting: { shape: 'singleTarget' },
        activation: {},
        effects: [
            { kind: 'damage', element: 'physical', power: 1.0 },
            {
                kind: 'applyDebuff',
                debuffId: 'bleed',
                stacks: 1,
                durationTicks: seconds(6),
            },
        ],
    },
    heal: {
        id: 'heal',
        name: 'Heal',
        source: 'item',
        kind: 'active',
        cooldownTicks: seconds(5),
        range: 25,
        targeting: { shape: 'allyLowestHp' },
        activation: {},
        effects: [{ kind: 'heal', power: 1.0 }],
    },
    greatsword_strike: {
        id: 'greatsword_strike',
        name: 'Greatsword Strike',
        source: 'ultimate',
        kind: 'active',
        cooldownTicks: seconds(30),
        range: 8,
        targeting: { shape: 'circle', radius: 8, maxTargets: 8 },
        activation: {},
        effects: [{ kind: 'damage', element: 'physical', power: 8.0 }],
    },
};
// ADR 0015 §4.5 / ADR 0025: sample + ITEM_SKILLS (`item.*`) + ULTIMATE_SKILLS
// (`ult.<job>.<name>`) を merge。命名空間が直交するため衝突なし
// (content.test.ts / item-skills.test.ts §J #1 で検証)。
const skills = {
    ...sampleSkills,
    ...ITEM_SKILLS,
    ...Object.fromEntries(ULTIMATE_SKILL_BY_ID),
};
/** Module-level registry. Lookup by SkillId (string). */
export const SKILL_REGISTRY = skills;
export function getSkill(id) {
    return skills[id];
}
/** Convenience: list of all skill IDs (sample + item catalogue). */
export const ALL_SKILL_IDS = Object.keys(skills);
//# sourceMappingURL=skills.js.map